import {useState} from "react";
import {styled as st} from '@mui/material/styles';
import apiService from "../../../../api/apiService.js";
import Switch from "@mui/material/Switch";
import {pink} from "@mui/material/colors";
import {alpha, FormControlLabel, Typography} from "@mui/material";
import MessageModal from "../../../common/MessageModal";


const GreenSwitch = st(Switch)(({theme}) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: pink[600],
        '&:hover': {
            backgroundColor: alpha(pink[600], theme.palette.action.hoverOpacity),
        },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: pink[600],
    },
}));

const CpToggle = (props) => {
    const { toggleName, initialState, shouldConfirm } = props;
    const [selected, setSelected] = useState(initialState === 'true');
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

    const toggle = () => {
        setSelected(!selected);

        // Make the API request when the toggle button is clicked
        apiService.updateCpx().then(response => {
            console.log("updated cpx");
        }).catch(error => {
            console.error(error);
        });
    };

    const confirmModalOptions = {
        message: selected ? "Are you sure you want to disable CPX mode?" : "Are you sure you want to enable CPX mode?",
        submit: "Yes",
        cancel: true,
        fnOnSubmit: toggle,
    };

    const changeHandler = () => {
        if (!shouldConfirm) {
            toggle();
            return;
        }

        setIsConfirmModalOpen(true);
    };

    return (
        <>
            {isConfirmModalOpen && (
                <MessageModal
                    modal={confirmModalOptions}
                    open={isConfirmModalOpen}
                    setOpen={setIsConfirmModalOpen}
                />
            )}
            <FormControlLabel
                control={<GreenSwitch/>}
                id={"toggle"}
                checked={selected}
                onChange={changeHandler}
                label={
                    <Typography style={{fontSize: "13px", marginLeft :"-5px"}}>{toggleName}</Typography>
                }
            />
        </>

    );
}
export default CpToggle;
